
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/sponsor-a-search",
      function () {
        return require("private-next-pages/products/estate-agents/sponsor-a-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/sponsor-a-search"])
      });
    }
  